import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { ProductType } from '../types';
import { StatsDataEntityInterface } from '../../../stats/data/entity.interface';
import { StatsDataAgentInterface } from '../../../stats/data/agent.interface';
import { StatsDataPropertyInterface } from '../../../stats/data/property.interface';

export class Snowplow2StatsAdapterProductType implements StatsAdapterInterface {
  /**
   * ListingStatusType key => ProductType value
   */
  public mapping: { [key: string]: ProductType } = {
    standard: 'standard',
    smart_ad: 'smartad',
    premium: 'premium',
    featured: 'featured',
    cts: 'cts',
    featured_agent: 'featured_agent',
    direct_from_developer_premium: 'direct_from_developer_premium',
    direct_from_developer_featured: 'direct_from_developer_featured',
    similar_properties_near: 'similar_properties_near',
    spotlight: 'spotlight',
  };

  /**
   *
   * @param rawData
   */
  constructor(protected rawData: StatsDataEntityInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): ProductType {
    if (
      (<StatsDataAgentInterface>this.rawData).isSmartAdAgent ||
      (<StatsDataAgentInterface>this.rawData).isAreaSpecialistProperty
    ) {
      return 'featured_agent';
    }

    // Returns the mapped value or falls back to 'standard' (WEB-2268)
    return this.mapping[(<StatsDataPropertyInterface>this.rawData).listingStatusDisplayed] || 'standard';
  }
}
